<template>
  <div>
    <el-dialog  title="表格设置" :visible.sync="dialogVisible" width="60%" @open="openDialog">
      <el-table ref="table" id="itxst" :row-key="row => row.prop" :data="tableData" stripe border> 
        <el-table-column v-for="item in tableColumns" :key="item.prop" :prop="item.prop" :label="item.label" :min-width="item.width">
          <template slot-scope="scope">
              <my-render v-if="item.render" :sc="scope" :row="scope.row" :render="item.render"></my-render>
              <span v-else>{{ scope.row[item.prop] }} </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import myRender from "./myRender.vue"
import Sortable from 'sortablejs';

export default {
  name: "customTableDialog",
  components: { myRender },
  props: {
    initTableData: {
      type: Array,
      default: () => [],
    },
    /** 缓存名 */
    tableType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      api: require("@/api/fund/paydoc").default,
      dialogVisible:false,
      tableColumns: [
        { 
          label: '列名称', 
          prop: 'label',
          render: (h, param) => {
            const elem = 
            <div>
              <el-input v-model={param.row.label}></el-input>
            </div>
            return (elem);
          }
        },
        { 
          label: '宽度',
          prop: 'width',
          render: (h, param) => {
            const elem = 
            <div>
              <el-input v-model={param.row.width } placeholder="请输入宽度(格式:180px)"></el-input>
            </div>
            return (elem);
          }
        },
        { 
          label: '对齐方式',
          prop: 'align',
          render: (h, param) => {
            const elem = 
            <div>
              <el-select v-model={param.row.align } placeholder="请选择对齐方式">
                <el-option label="左对齐" value="left"></el-option>
                <el-option label="居中对齐"value="center"></el-option>
                <el-option label="右对齐" value="right"></el-option>
              </el-select>
            </div>
            return (elem);
          }
        },
        { 
          label: '显示',
          prop: 'isShow',
          render: (h, param) => {
            const elem = 
            <div>
              <el-switch v-model={param.row.isShow} active-color="#13ce66"></el-switch>
            </div>
            return (elem);
          }
        },
        { 
          label: '拖拽排序列', 
          prop: 'label',
          width: '35px',
          align: 'center',
          
          render: (h, param) => {
            const elem = 
            <div class={{
                'my-handle': true
              }}>
              <i class="el-icon-sort"></i>
            </div>
            return (elem);
          }
        },
      ],
      tableData:[]
    }
  },
  methods: {
    openDialog() {
      this.sortable()
      this.dialogVisible = true;
      this.tableData = this.initTableData
      //获取缓存 如果有缓存就赋值
      let customTable =  localStorage.getItem(this.tableType);
      if(customTable){
        this.tableData = JSON.parse(customTable);
      }
    },
    sortable(){
      this.$nextTick(() => {
        var el = this.$refs.table.$el.querySelector(".el-table__body-wrapper tbody");
        let that = this
        let options = {
          animation: 300,
          handle:".my-handle",
          onEnd: function (evt) {
            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            // 交换被移动行和目标行的位置
            const draggedItem = that.tableData.splice(oldIndex, 1)[0];
            that.tableData.splice(newIndex, 0, draggedItem);
          },
        };
        Sortable.create(el, options);
      });
    },
    onSave(){
      this.dialogVisible = false
      localStorage.setItem(this.tableType,JSON.stringify(this.tableData));
      this.$emit('onSave',this.tableData)
    }
  }
};
</script>